import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./RecruTech.css";
import { Link } from "react-router-dom";

function RecruTech() {
  const services = [
    {
      title: "Permanent Recruitment",
      desc: "End-to-end hiring solutions for full-time roles across industries.",
      icon: "👥",
    },
    {
      title: "Contract Staffing",
      desc: "Flexible contract-based workforce solutions for short & long-term needs.",
      icon: "📄",
    },
    {
      title: "Security & Facility Staffing",
      desc: "Trained security guards, supervisors, housekeeping & facility staff.",
      icon: "🛡️",
    },
    {
      title: "HR Outsourcing",
      desc: "Complete HR operations including payroll, compliance & onboarding.",
      icon: "🧾",
    },
    {
      title: "Bulk & Mass Hiring",
      desc: "High-volume recruitment for factories, retail, logistics & projects.",
      icon: "🏭",
    },
    {
      title: "Executive Search",
      desc: "Leadership & senior-level hiring with confidential search processes.",
      icon: "🎯",
    },
  ];

  return (
    <>
      <Navbar />

      {/* HERO */}
      <section className="recrutech-hero">
        <div className="recrutech-hero-content">
          <h1>Klyzen RecruTech</h1>
          <h2>Consulting • Recruitment • Workforce Solutions</h2>
          <p>
            Building reliable, skilled, and scalable workforces for organizations
            across industries.
          </p>
        </div>
      </section>

      {/* ABOUT */}
      <section className="recrutech-section recrutech-about">
        <h2>About Klyzen RecruTech</h2>
        <p>
          Klyzen RecruTech, a strategic division of{" "}
          <strong>Klyzen Ventures LLP</strong>, delivers professional consulting,
          recruitment, and manpower solutions. We help organizations hire,
          manage, and scale their workforce efficiently while ensuring compliance
          and quality.
        </p>
      </section>

      {/* SERVICES */}
      <section className="recrutech-section recrutech-services">
        <h2>Our Consulting & Recruitment Services</h2>
        <p className="section-subtitle">
          Complete workforce solutions tailored to your business needs
        </p>

        <div className="services-grid">
          {services.map((service, idx) => (
            <div key={idx} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="recrutech-section recrutech-industries">
        <h2>Industries We Serve</h2>

        <div className="industries-grid">
          <span>IT & Technology</span>
          <span>Manufacturing</span>
          <span>Healthcare</span>
          <span>Retail & E-commerce</span>
          <span>Logistics & Warehousing</span>
          <span>Hospitality</span>
          <span>Construction</span>
          <span>Education</span>
          <span>Security Services</span>
          <span>Corporate Offices</span>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="recrutech-section recrutech-why">
        <h2>Why Choose Klyzen RecruTech</h2>

        <div className="why-grid">
          <div className="why-card">✔ Verified & Skilled Workforce</div>
          <div className="why-card">✔ Fast Hiring Turnaround</div>
          <div className="why-card">✔ Legal & Payroll Compliance</div>
          <div className="why-card">✔ Industry-Specific Expertise</div>
          <div className="why-card">✔ Scalable Manpower Solutions</div>
          <div className="why-card">✔ Trusted by Growing Enterprises</div>
          <div className="why-card">
            ✔ Background Verification & Compliance Assurance
            </div>
            <div className="why-card">
            ✔ Pan-India & Scalable Workforce Support
            </div>
                </div>
      </section>

      {/* CTA */}
      <section className="recrutech-cta">
        <h2>Hire the Right Talent with Confidence</h2>
        <p>
          Partner with Klyzen RecruTech for reliable consulting & recruitment
          solutions.
        </p>
        <Link to="/contact" className="cta-btn">
          Contact Our Team
        </Link>
      </section>

      <Footer />
    </>
  );
}

export default RecruTech;
